import React from 'react';

export const GraphIcon = ({ width = 20 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="2" width="1" height="6" fill="#0097CE" />
      <rect x="2.5" y="4" width="1" height="4" fill="#0097CE" />
      <rect x="4.5" y="6" width="1" height="2" fill="#0097CE" />
      <rect x="6.5" y="1" width="1" height="7" fill="#0097CE" />
    </svg>
  );
};

export default GraphIcon;
